<template>
  <div>
    <component :is="isHomeRoute ? 'div' : 'Sticky'">
      <div class="navbar-stack">
        <div
          v-if="showDownloadBanner"
          class="download-top-banner"
        >
          <div class="download-top-banner__brand">
            <img
              class="download-top-banner__logo"
              src="/assets/12k-new.avif"
              alt="12K"
              @click="$router.push('/home')"
            >
            <div class="download-top-banner__meta">
              <div class="download-top-banner__name">12K</div>
              <div
                class="download-top-banner__stars"
                aria-hidden="true"
              >
                <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
              </div>
            </div>
          </div>
          <div class="download-top-banner__actions">
            <button
              type="button"
              class="download-top-banner__action"
              @click="appInstall"
            >
              {{ downloadBannerText }}
            </button>
            <button
              type="button"
              class="download-top-banner__close"
              aria-label="Close download banner"
              @click="dismissDownloadBanner"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line
                  x1="18"
                  y1="6"
                  x2="6"
                  y2="18"
                />
                <line
                  x1="6"
                  y1="6"
                  x2="18"
                  y2="18"
                />
              </svg>
            </button>
          </div>
        </div>

        <nav class="navbar navbar-horizontal navbar-expand-lg py-0 navbar-branded">
        <div class="container-fluid">
          <div
            class="navbar-brand"
            :class="$route.path !== '/home' ? 'd-flex justify-content-between' : ''
              "
          >
            <!-- <div
              class="d-flex flex-column banking-icons my-auto ml-1 mr-3"
              v-if="$route.path !== '/auth/login'"
            >
              <i
                class="fas fa-chevron-left mx-auto my-1 text-xl text-dark"
                @click=" $router.go(-1)"
                v-if="$route.path !== '/home'"
              ></i>
            </div> -->
            <img
              src="/assets/12k-new.avif"
              alt="12K"
              @click=" $router.push('/home')"
            />
            <!-- LOGO -->
          </div>
          <div class="d-flex">
            <div
              class="d-flex"
              v-if="$route.path !== '/auth/login' && authUser"
            >

              <span class="my-auto pr-3 navbar-balance">
                <span class="text-sm text-uppercase">
                  <img
                    loading="lazy"
                    class="coin"
                    src="https://storage.googleapis.com/spacetech2/phoenix888/coin.png"
                    alt=""
                  >
                </span>
                <span class="navbar-balance__amount text-md">
                  <b>{{ Number($store.state.authUser.amount).toLocaleString() }}</b> MMK
                </span>
              </span>
            </div>

            <!-- <div class="mr-3 pt-2" @click="appInstall()" v-if="!authUser">
              <img class="ml-2 my-auto mx-auto" style="width: 1.5rem;" src="https://storage.googleapis.com/spacetech2/shwemyanmar/download.png" alt="">
            </div> -->

            <div class="navbar-actions">
              <div
                v-if="!$store.state.authUser.name"
                class="navbar-auth-actions"
              >
                <button
                  type="button"
                  class="navbar-btn navbar-btn--signup"
                  @click="$router.push('/auth/register')"
                >
                  {{ $t('auth.sign_up') }}
                </button>

                <button
                  type="button"
                  class="navbar-btn navbar-btn--login"
                  @click="$router.push('/auth/login')"
                >
                  {{ $t('auth.login') }}
                </button>
              </div>
            </div>

            <!-- <div class="nav-link px-1 pl-3 mx-0 d-flex justify-content-between">
              <a href="#" @click="showTopImage()" style="position: relative">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/luckywin/icons/notification%20(1).png" style="width: 25px;">
              </a>
            </div>

            <van-popup v-model="showTop" round position="top" :style="{ height: '40%' }">
              <h3 class="pl-3 py-3">Latest Messages</h3>
                <div v-for="(list, index) in messages" :key="index" class="mx-4 py-3" style="border-bottom: 1px solid #CFCFCF" v-show="messages.length > 0">
                  <div class="d-flex justify-content-between">
                    <h4>{{ list.title }}</h4><h4>{{ timeFormat(list.created_at) }}</h4>
                  </div>
                  <span class="text-sm">{{ list.message }}</span>
                </div>
                <van-empty description="No Notifications Yet!" v-show="messages.length === 0"/>
            </van-popup> -->

            <!-- <div class="nav-link px-1 mx-0 d-flex justify-content-between">
              <a href="https://t.me/hulk333vip">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/hulk333/icons/telegram%20(1).png" style="width: 25px;">
              </a>
            </div> -->

            <!-- Language -->
            <div
              class="nav-link d-flex justify-content-between px-1 pt-1"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div id="navbar-language">
                <img
                  :src="$t('images.lang-img')"
                  alt=""
                  class="mr-2"
                  style="width: 25px; height: 25px; border-radius: 50%;"
                />
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbar-language"
            >
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('en')"
              ><img
                  src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />
                {{ $t("en") }}</a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('mm')"
              ><img
                  src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t('mm') }}</a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('cn')"
              ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("cn") }}</a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('th')"
              ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("th") }}</a>
            </div>
            <!-- <div class="my-auto pr-2" v-if="alreadyGranted && authUser">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/b067eede-486d-4336-e303-968134d62f00/public" style="width: auto; height: 35px;" alt="" @click=" askNotificationPermission()">
                  </div> -->
          </div>

        </div>
        </nav>
      </div>
    </component>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Sticky },
  data() {
    return {
      messages: [],
      showTop: false,
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
      showDownloadBanner: false,
    };
  },
  computed: {
    isHomeRoute() {
      const path = this.$route.path;
      return path === '/home' || path === '/';
    },
    downloadBannerText() {
      return this.$store.state.language === 'en'
        ? 'Download'
        : 'ဒေါင်းလုဒ်';
    },
  },
  methods: {
    appInstall() {
      const userAgent = navigator.userAgent;

      // console.log(userAgent);

      if (/android/i.test(userAgent)) {
        window.location.href = 'https://storage.googleapis.com/spacetech2/buffaloboss/app-release.apk?ignoreCache=1';
      } else {
        // Optional: Show a message or fallback
        alert('Unsupported device.');
      }
    },
    dismissDownloadBanner() {
      this.showDownloadBanner = false;
      try {
        localStorage.setItem('skp_download_banner_dismissed', '1');
      } catch (e) {
        /* ignore */
      }
    },
    timeFormat(time) {
      return moment(time).startOf('hour').fromNow();
    },
    async getMessages() {
      try {
        const res = await axios.get('/messages');
        this.messages = res.data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showTopImage() {
      this.showTop = !this.showTop;
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === 'granted') {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission granted!'
              : 'အသိပေးချက်အတည်ပြုပြီးပြီ'
          );
        } else {
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission denied!'
              : 'အသိပေးချက်အတည်ပြုမပြီးပြီ'
          );
        }
      });
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            this.$router.go();
          } else {
            this.$router.push('/home');
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    closeNavCollapse() {
      $('#navbar-default').collapse('hide');
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
      $('#navbar-default').collapse('hide');
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => { });
      $('#navbar-default').collapse('hide');
    },
    redirectRoute(path) {
      if (path === '2d') {
        this.$router.push('/user/2d');
      } else {
        this.$router.push('/user/3d');
      }
      return true;
    },
  },
  async mounted() {
    // this.getMessages();
    // if(window.Notification.permission === 'granted') {
    //   this.alreadyGranted = false;
    // }

    try {
      this.showDownloadBanner = localStorage.getItem('skp_download_banner_dismissed') !== '1';
    } catch (e) {
      this.showDownloadBanner = true;
    }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  }
};
</script>
<style scoped>
.navbar-stack {
  width: 100%;
}

.download-top-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  padding: 0.25rem 1rem 0.25rem 0.75rem;
  background: #082612;
  border-bottom: 2px solid #E8B923;
  box-shadow: 0 2px 10px rgba(8, 38, 18, 0.4);
  z-index: 1030;
}

.download-top-banner__brand {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
}

.download-top-banner__logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
  cursor: pointer;
}

.download-top-banner__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.125rem;
  padding: 0.125rem 0;
  min-width: 0;
}

.download-top-banner__name {
  color: #FFFFFF;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.2;
  white-space: nowrap;
}

.download-top-banner__stars {
  display: flex;
  gap: 0.125rem;
  color: #E8B923;
  font-size: 0.875rem;
}

.download-top-banner__stars span {
  line-height: 1;
}

.download-top-banner__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.download-top-banner__action {
  min-height: 2.15rem;
  padding: 0.45rem 1.15rem;
  border: none;
  border-radius: 0.4rem;
  background: #E8B923;
  color: #0D3B1A;
  font-size: 0.92rem;
  font-weight: 800;
  font-family: Pyidaungsu, Padauk, sans-serif;
  line-height: 1.3;
  white-space: nowrap;
  box-shadow: none;
  cursor: pointer;
}

.download-top-banner__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.15rem;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #FFFFFF;
  cursor: pointer;
}

.download-top-banner__close:active,
.download-top-banner__action:active {
  transform: scale(0.96);
}

/* CSS */
.login-btn {
  background: transparent;
  border: 1px solid #0D3B1A;
  border-radius: 3px;
  padding: .3rem 1.5rem;
  color: #0D3B1A;
}

.coin {
  height: 1.3rem;
  margin-top: -0.25rem;
  margin-right: 0.4rem;
  animation: flip-coin-49989627 2.5s linear infinite;
  animation-delay: 0s;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  transform-style: preserve-3d;
  /* Keeps the 3D effect */
}

/* Define the keyframes for the 3D flip animation */
@keyframes flip-coin-49989627 {
  0% {
    transform: rotateY(0deg);
    /* Front face */
  }

  50% {
    transform: rotateY(180deg);
    /* Back face */
  }

  100% {
    transform: rotateY(360deg);
    /* Front face again */
  }
}

.navbar {
  min-height: 54px;
  padding: 0px 14px;
  box-shadow: 0 4px 16px rgba(26, 46, 31, 0.08);
}

.navbar-branded {
  background: #0D3B1A !important;
  border: none !important;
  border-bottom: 2px solid #E8B923 !important;
  box-shadow: 0 2px 8px rgba(8, 38, 18, 0.18);
}

.navbar-horizontal .navbar-brand img {
  height: 54px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25));
}

.nav-link {
  cursor: pointer;
}

.navbar-brand.brand-text {
  font-size: 20px;
  color: #E8B923;
  margin-left: 0px;
  margin-right: 10px;
}

.navbar-brand {
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
}

.bg-default {
  background-color: #FFFFFF !important;
}


.navbar-toolbar {
  gap: 0.35rem;
  flex-shrink: 0;
}

.navbar-balance {
  border-right: 1px solid rgba(255, 255, 255, 0.28);
}

.navbar-balance__amount {
  color: #FFFFFF;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.navbar-auth-actions {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.25rem;
  flex-shrink: 0;
}

.navbar-btn {
  position: relative;
  overflow: hidden;
  min-height: 1.9rem;
  border-radius: 0.55rem;
  padding: 0.3rem 0.72rem;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.01em;
  white-space: nowrap;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.24);
  flex-shrink: 0;
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease, box-shadow 0.2s ease;
}

.navbar-btn::after {
  position: absolute;
  top: -50%;
  left: -80%;
  width: 45%;
  height: 200%;
  background: rgba(255, 255, 255, 0.28);
  content: "";
  transform: rotate(22deg);
  transition: left 0.45s ease;
}

.navbar-btn__icon {
  font-size: 0.72rem;
  margin-right: 0.2rem;
}

.navbar-btn--signup {
  border: 1px solid #E8B923;
  background: #E8B923;
  color: #082612;
  box-shadow: none;
}

.navbar-btn--login {
  border: 1px solid #FFFFFF;
  background: #FFFFFF;
  color: #0D3B1A;
  box-shadow: none;
}

.navbar-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.08);
}

.navbar-btn:hover::after {
  left: 140%;
}

.navbar-btn:active {
  transform: translateY(1px) scale(0.98);
}

.navbar-btn:focus-visible {
  outline: 2px solid #0D3B1A;
  outline-offset: 2px;
}

.navbar-lang {
  margin-left: 0.15rem;
}

.navbar-lang__flag {
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 50%;
  border: 1px solid rgba(232, 185, 35, 0.65);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.2);
}

@media (max-width: 767.98px) {
  .navbar-brand {
    font-size: 14px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .navbar-horizontal .navbar-brand img {
    height: 3.5rem;
  }

  .navbar-toolbar {
    gap: 0.2rem;
  }

  .navbar-auth-actions {
    gap: 0.18rem;
  }

  .navbar-btn {
    min-height: 1.7rem;
    padding: 0.28rem 0.5rem;
    font-size: 0.72rem;
  }

  .navbar-btn__icon {
    font-size: 0.52rem;
    margin-right: 0.1rem;
  }

  .navbar-lang__flag {
    width: 1.2rem;
    height: 1.2rem;
  }
}
</style>
